import { MetadataSerialization, RepairProperties } from '@adaptiva/metadata/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseFormAuthoringComponent } from './base-form-authoring.component';

@Component({
	standalone: false,
	selector: 'ada-repair-properties',
	templateUrl: './form-authoring-template.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class RepairPropertiesComponent extends BaseFormAuthoringComponent<RepairProperties> {

	public override propertyConstructor: MetadataSerialization.Deserializable<RepairProperties> = RepairProperties;

}
